












import { Component, Vue } from "vue-property-decorator";

@Component
export default class ToggleChart extends Vue {
  get isChartEnabled(): boolean {
    return this.$store.getters["ui/priceChartOptions"].enabled;
  }

  private toggleChart(): void {
    this.$store.dispatch("ui/setPriceChartOption", { option: "enabled", value: !this.isChartEnabled });
  }
}
